'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AjaxHelper = function () {
    function AjaxHelper() {
        var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'application/json; charset=UTF-8';

        _classCallCheck(this, AjaxHelper);

        this.contentType = '';

        this.contentType = contentType;
    }

    _createClass(AjaxHelper, [{
        key: 'sendRequest',
        value: function sendRequest(url) {
            var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'POST';

            var httpRequest = new XMLHttpRequest();

            httpRequest.onreadystatechange = function (ev) {
                if (httpRequest.readyState !== 4) return;

                if (httpRequest.status !== 200) {
                    console.error('Error requesting URL: ' + url + ', Status: ' + httpRequest.status + '.', httpRequest.responseText);
                } else if (handler && typeof handler === 'function') {
                    var responseObject = { responseParseFailed: false };
                    try {
                        responseObject = _extends({}, responseObject, JSON.parse(httpRequest.responseText));
                    } catch (e) {
                        responseObject.responseParseFailed = true;
                        console.error('Error calling server through Ajax.', e);
                    }

                    handler(httpRequest, responseObject);
                }
            };
            httpRequest.open(type, url, true);
            httpRequest.setRequestHeader('Content-type', this.contentType);
            httpRequest.setRequestHeader('X-XSRF-TOKEN', getCookie('XSRF-TOKEN'));
            httpRequest.send((typeof body === 'undefined' ? 'undefined' : _typeof(body)) === 'object' ? JSON.stringify(body) : body);
        }
    }]);

    return AjaxHelper;
}();

exports.default = AjaxHelper;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/ajaxHelper.js
// module id = 82
// module chunks = 0